export default "__VITE_ASSET__69a5d8d5__"